// Floating Labels in Forms
const float = function() {
  const group = document.querySelectorAll('.customer-field')

  group.forEach(function(ele) {

    const input = ele.querySelector('input')

    input.addEventListener('focus', function(){
      ele.classList.add('label-up')
      ele.classList.add('focus')
    })

    input.addEventListener('blur', function() {
      ele.classList.remove('focus')
      if(!input.value) {
        ele.classList.remove('label-up')
      }
    })

  })
}

float()

// Show/Hide Password
const showPassword = document.querySelectorAll('.show-password')
for (let i = 0; i < showPassword.length; i++) {
  showPassword[i].addEventListener('click', function(){
    const x = showPassword[i].closest(".customer-field").querySelector(".password-field")
    if (x.type === "password") {
      x.type = "text"
      showPassword[i].textContent = "Hide"
    } else {
      x.type = "password"
      showPassword[i].textContent = "Show"
    }
  })
}